import React, { useState } from 'react';
import { Alert, Box, Button, Paper } from '@mui/material';
import InhouseTimeline from './InhouseTimeline';
import InhouseEntryEditor from './InhouseEntryEditor';
import { IInhouseEntry } from './types';
import { hasPermission } from '../../utils/permissionUtils';

interface InhouseModuleProps {
  onClose: () => void;
  currentUser: any;
}

type View =
  | { type: 'timeline' }
  | { type: 'editor'; entry?: IInhouseEntry };

const InhouseModule: React.FC<InhouseModuleProps> = ({ onClose, currentUser }) => {
  const [view, setView] = useState<View>({ type: 'timeline' });
  const [refreshKey, setRefreshKey] = useState(0);
  const canAccessInhouse =
    hasPermission(currentUser, 'inhouse:read') ||
    hasPermission(currentUser, 'inhouse:create') ||
    hasPermission(currentUser, 'inhouse:update') ||
    hasPermission(currentUser, 'inhouse:delete');

  const handleCreateNew = () => {
    setView({ type: 'editor' });
  };

  const handleEdit = (entry: IInhouseEntry) => {
    setView({ type: 'editor', entry });
  };

  const handleEditorClose = () => {
    setView({ type: 'timeline' });
  };

  const handleSaved = () => {
    setRefreshKey(prev => prev + 1);
    setView({ type: 'timeline' });
  };

  if (!canAccessInhouse) {
    return (
      <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f5f5f5', p: 3 }}>
        <Paper sx={{ maxWidth: 560, width: '100%', p: 3 }}>
          <Alert severity="warning" sx={{ mb: 2 }}>
            Du har inte behörighet att visa Inhouse. Rollen behöver ha <strong>`inhouse:read`</strong> eller en starkare Inhouse-behörighet.
          </Alert>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button variant="contained" onClick={onClose} sx={{ bgcolor: '#1B3967', '&:hover': { bgcolor: '#0f2341' } }}>
              Stäng
            </Button>
          </Box>
        </Paper>
      </Box>
    );
  }

  if (view.type === 'editor') {
    return (
      <InhouseEntryEditor
        entry={view.entry}
        onClose={handleEditorClose}
        onSaved={handleSaved}
        currentUser={currentUser}
      />
    );
  }

  return (
    <InhouseTimeline
      onClose={onClose}
      onCreateNew={handleCreateNew}
      onEdit={handleEdit}
      currentUser={currentUser}
      refreshKey={refreshKey}
    />
  );
};

export default InhouseModule;
